// Upload configuration settings
export const UPLOAD_CONFIG = {
  // PDF processing settings
  PDF: {
    // Number of pages to process concurrently (higher = faster but more memory usage)
    MAX_CONCURRENCY: 3,
    // Scale factor for PDF rendering (lower = faster but lower quality)
    RENDER_SCALE: 1.2,
    // JPEG quality for image compression (0.1 to 1.0, lower = smaller file)
    JPEG_QUALITY: 0.8,
    // Maximum file size in MB before compression warning
    MAX_FILE_SIZE_MB: 50,
  },
  
  // S3 upload settings
  S3: {
    // Upload timeout in milliseconds
    TIMEOUT: 30000,
    // Number of retry attempts for failed uploads
    MAX_RETRIES: 3,
    // Retry delay in milliseconds (will be multiplied by attempt number)
    RETRY_DELAY: 1000,
  },
  
  // UI settings
  UI: {
    // Show progress bar during upload
    SHOW_PROGRESS: true,
    // Show detailed status messages
    SHOW_STATUS: true,
  }
};

// Helper function to get configuration value
export const getUploadConfig = (key: string) => {
  const keys = key.split('.');
  let value: any = UPLOAD_CONFIG;
  
  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      return undefined;
    }
  }
  
  return value;
}; 